import React from "react";
import axios from "axios";

function ThirdPartyLogin() {
  const thirdPartyLogin = (method) => {
    const requestData = {
      type: method,
    };
    axios
      .post(`/api/User/SSOLogin`, requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("login link:", "response.data");
          window.location.href = response.data;
        } else {
          console.log("Captcha failed:", response);
          // Token is invalid, log out the user
        }
      })
      .catch((error) => {
        console.error("發送SSOLogin的回應有錯誤：", "error");
        console.log("發送SSOLogin資訊有錯誤", "requestData");
      })
      .finally(() => {
        // setIsLoading(false); // Mark loading as finished regardless of success or error
      });
  };
  return (
    <div className="d-flex align-items-center pt-2">
      <div
        className="pe-2 cursor-pointer"
        onClick={() => {
          thirdPartyLogin("Facebook");
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="41"
          viewBox="0 0 40 40"
                  fill="none"
                  display="none"
        >
          <g clipPath="url(#clip0_2270_18933)">
            <path
              d="M40 20C40 8.95438 31.0456 0 20 0C8.95437 0 0 8.95422 0 20C0 29.9825 7.31375 38.2567 16.875 39.757V25.7813H11.7969V20H16.875V15.5938C16.875 10.5813 19.8609 7.8125 24.4292 7.8125C26.6175 7.8125 28.9062 8.20313 28.9062 8.20313V13.125H26.3844C23.8997 13.125 23.125 14.6667 23.125 16.2484V20H28.6719L27.7852 25.7813H23.125V39.757C32.6863 38.2567 40 29.9827 40 20Z"
              fill="#1877F2"
            />
            <path
              d="M27.7852 25.7812L28.6719 20H23.125V16.2484C23.125 14.6666 23.8998 13.125 26.3844 13.125H28.9062V8.20312C28.9062 8.20312 26.6175 7.8125 24.4292 7.8125C19.8609 7.8125 16.875 10.5813 16.875 15.5938V20H11.7969V25.7812H16.875V39.757C17.9088 39.919 18.9536 40.0003 20 40C21.0464 40.0003 22.0912 39.9191 23.125 39.757V25.7812H27.7852Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_2270_18933">
              <rect width="40" height="41" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div
        className="pe-2 cursor-pointer"
        onClick={() => {
          thirdPartyLogin("Google");
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
        >
          <path
            d="M43.611 20.534H42V20.451H24V28.451H35.303C33.654 33.108 29.223 36.451 24 36.451C17.373 36.451 12 31.078 12 24.451C12 17.824 17.373 12.451 24 12.451C27.059 12.451 29.842 13.605 31.961 15.49L37.618 9.83305C34.046 6.50405 29.268 4.45105 24 4.45105C12.955 4.45105 4 13.406 4 24.451C4 35.496 12.955 44.451 24 44.451C35.045 44.451 44 35.496 44 24.451C44 23.11 43.862 21.801 43.611 20.534Z"
            fill="#FFC107"
          />
          <path
            d="M6.30469 15.142L12.8757 19.9611C14.6537 15.5591 18.9597 12.451 23.9987 12.451C27.0577 12.451 29.8407 13.605 31.9597 15.49L37.6167 9.83305C34.0447 6.50405 29.2667 4.45105 23.9987 4.45105C16.3167 4.45105 9.65469 8.78805 6.30469 15.142Z"
            fill="#FF3D00"
          />
          <path
            d="M24.0003 44.4511C29.1663 44.4511 33.8603 42.4741 37.4093 39.2591L31.2193 34.0211C29.1439 35.5995 26.6078 36.4531 24.0003 36.4511C18.7983 36.4511 14.3813 33.1341 12.7173 28.5051L6.19531 33.5301C9.50531 40.0071 16.2273 44.4511 24.0003 44.4511Z"
            fill="#4CAF50"
          />
          <path
            d="M43.611 20.534H42V20.451H24V28.451H35.303C34.5142 30.6675 33.0934 32.6042 31.216 34.022L31.219 34.0201L37.409 39.258C36.971 39.656 44 34.451 44 24.451C44 23.11 43.862 21.801 43.611 20.534Z"
            fill="#1976D2"
          />
        </svg>
      </div>
      <div
        className="svg-line cursor-pointer"
        onClick={() => {
          thirdPartyLogin("Line");
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
        >
          <path
            d="M24.2969 15.8261V22.1776C24.2969 22.3417 24.1719 22.4667 24.0078 22.4667H22.9922C22.8906 22.4667 22.8047 22.412 22.7578 22.3495L19.8438 18.4198V22.1854C19.8438 22.3495 19.7188 22.4745 19.5547 22.4745H18.5391C18.375 22.4745 18.25 22.3495 18.25 22.1854V15.8339C18.25 15.6698 18.375 15.5448 18.5391 15.5448H19.5469C19.6328 15.5448 19.7344 15.5917 19.7813 15.6698L22.6953 19.5995V15.8339C22.6953 15.6698 22.8203 15.5448 22.9844 15.5448H24C24.1641 15.537 24.2969 15.6698 24.2969 15.8182V15.8261ZM16.9766 15.537H15.9609C15.7969 15.537 15.6719 15.662 15.6719 15.8261V22.1776C15.6719 22.3417 15.7969 22.4667 15.9609 22.4667H16.9766C17.1406 22.4667 17.2656 22.3417 17.2656 22.1776V15.8261C17.2656 15.6776 17.1406 15.537 16.9766 15.537ZM14.5234 20.8573H11.7422V15.8261C11.7422 15.662 11.6172 15.537 11.4531 15.537H10.4375C10.2734 15.537 10.1484 15.662 10.1484 15.8261V22.1776C10.1484 22.2557 10.1719 22.3182 10.2266 22.3729C10.2813 22.4198 10.3438 22.451 10.4219 22.451H14.5C14.6641 22.451 14.7891 22.326 14.7891 22.162V21.1464C14.7891 20.9979 14.6641 20.8573 14.5156 20.8573H14.5234ZM29.6562 15.537H25.5703C25.4219 15.537 25.2812 15.662 25.2812 15.8261V22.1776C25.2812 22.326 25.4062 22.4667 25.5703 22.4667H29.6484C29.8125 22.4667 29.9375 22.3417 29.9375 22.1776V21.1542C29.9375 20.9901 29.8125 20.8651 29.6484 20.8651H26.875V19.8026H29.6484C29.8125 19.8026 29.9375 19.6776 29.9375 19.5136V18.4901C29.9375 18.3261 29.8125 18.2011 29.6484 18.2011H26.875V17.1307H29.6484C29.8125 17.1307 29.9375 17.0057 29.9375 16.8417V15.8261C29.9297 15.6776 29.8047 15.537 29.6484 15.537H29.6562ZM40 7.74793V33.2167C39.9922 37.2167 36.7109 40.4588 32.7031 40.451H7.23438C3.23439 40.4432 -0.00779841 37.1542 1.40894e-05 33.1542V7.68543C0.00782658 3.68544 3.29689 0.443251 7.29688 0.451064H32.7656C36.7656 0.458876 40.0078 3.74012 40 7.74793ZM34.5 18.6932C34.5 12.1776 27.9609 6.87293 19.9375 6.87293C11.9141 6.87293 5.37501 12.1776 5.37501 18.6932C5.37501 24.5292 10.5547 29.4276 17.5547 30.3573C19.2578 30.7245 19.0625 31.3495 18.6797 33.6464C18.6172 34.0135 18.3828 35.0839 19.9375 34.4354C21.4922 33.787 28.3203 29.4979 31.3828 25.9823C33.4922 23.662 34.5 21.3104 34.5 18.7089V18.6932Z"
            fill="#06C152"
          />
        </svg>
      </div>
    </div>
  );
}

export default ThirdPartyLogin;
